import { render, staticRenderFns } from "./HiveDetailsHeader.vue?vue&type=template&id=ec639ae4&scoped=true"
import script from "./HiveDetailsHeader.vue?vue&type=script&lang=ts"
export * from "./HiveDetailsHeader.vue?vue&type=script&lang=ts"
import style0 from "./HiveDetailsHeader.vue?vue&type=style&index=0&id=ec639ae4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec639ae4",
  null
  
)

export default component.exports